import Vue from "vue";
import {
  getRequest,
  putRequest,
} from "@/scripts/ProfiControlRequests/CrudManager";
import type {
  GratificationSettings,
} from "@/components/settings/scripts/Gratification";

const fetchGratificationSettings = async (token: string)
    : Promise<{ response: GratificationSettings | undefined, errorCode: number | undefined}> => {
    const url = `${Vue.prototype.$config.GatewayUrl}/api/v1/admin/webcharge/configuration/gratification`;
    let response = undefined;
    let errorCode = undefined;

    await getRequest<GratificationSettings>(url, token)
        .then((result) => {
            response = result.data;
        })
        .catch((result) => {
            errorCode = result.response.status;
        });

    return {
        response,
        errorCode
    };
}

const updateGratificationSettings = async (token: string, gratificationSettings: GratificationSettings)
    : Promise<{ response: GratificationSettings | undefined, errorCode: number | undefined}> => {
    const url = `${Vue.prototype.$config.GatewayUrl}/api/v1/admin/webcharge/configuration/gratification`;
    let response = undefined;
    let errorCode = undefined;

    await putRequest<GratificationSettings>(url, gratificationSettings, token)
        .then((result) => {
            response = result.data;
        })
        .catch((result) => {
            errorCode = result.response.status;
        });


    return {
        response,
        errorCode
    };
}

export {
    fetchGratificationSettings,
    updateGratificationSettings
}
